module.exports = __webpack_public_path__ + "img/ARCH_05_video_prew.8d27dbd1.jpg";